import { createStore } from "redux";

const initialState = {
    isCompose: false,
    refreshMessage: false,
    isDraft: false,
    categoryId: null,
    searchMessage: null,
    triggerPaninate: false,
    filterObject: {},
    trigger: false,
    isChecked: false,
    selectedMessages: [],
    triggerDraft: false,
    refreshCount: false,
    count: null,
};

const createReducer = (state = initialState, action) => {

    switch (action.type) {
        case "IS_COMPOSE":
            return { ...state, isCompose: action.payload, isDraft: action.isDraft ?? false };
        case "REFRESH_MESSAGE":
            return { ...state, refreshMessage: action.payload };
        case "ACTIVE_CATEGORY_iD":
            return { ...state, categoryId: action.payload };
        case "SEARCH_MESSAGE":
            return { ...state, searchMessage: action.payload };
        case "TRIGGER_PAGINATE":
            return { ...state, triggerPaninate: action.payload };
        case "FILTER_OBJECT":
            return { ...state, filterObject: action.payload, trigger: action.value };
        case "IS_CHECKED":
            return { ...state, isChecked: action.payload };
        case "SELECTED_MESSAGES":
            return { ...state, selectedMessages: action.payload };
        case "TRIGGER_DRAFT":
            return { ...state, triggerDraft: action.payload };
        case "REFRESH_COUNT":
            return { ...state, refreshCount: action.payload };
        case "count_update":
            return { ...state, count: action.payload };
        default:
            return state;
    }
};

const store = createStore(createReducer);

export default store;